import { AfterViewInit, Component, EventEmitter, Injectable, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CheckboxService {
  checkboxState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  displayName: string = '';
  buttonType: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private functionCallSource = new Subject<string>();
  private functionCallSource2 = new Subject<string>();
  private functionCallSource3 = new Subject<string>();

  functionDeselect = this.functionCallSource.asObservable();
  functionSelect = this.functionCallSource2.asObservable();
  functionPrint = this.functionCallSource3.asObservable();

  deselectAll(columnKey: string): void {
    this.functionCallSource.next(columnKey);
  }

  selectAll(columnKey: string): void {
    this.functionCallSource2.next(columnKey);
  }

  print(columnKey: string): void {
    this.functionCallSource3.next(columnKey);
  }

  updateCheckboxState(newState: boolean) {
    this.checkboxState.next(newState);
  }

  updateButton(newState: boolean) {
    this.buttonType.next(newState);
  }
}

@Component({
  selector: 'app-cell-renderer',
  template: `<mat-checkbox #checkboxes [id]="params.displayName" [(ngModel)]="params.displayName" (change)="onCheckboxChange($event, params)"></mat-checkbox>`,
})
export class CustomRendererComponent implements ICellRendererAngularComp, AfterViewInit {

  @ViewChildren(MatCheckbox) checkboxes!: QueryList<MatCheckbox>;

  checkboxState: boolean = true;

  constructor(private http: HttpClient, public checkboxService: CheckboxService) {
    checkboxService.checkboxState.subscribe(state => {
      this.checkboxState = state;
    });
  }

  ngAfterViewInit() {
    // Logic to execute after the view has been initialized
    // console.log('View has been initialized!', this.checkboxes);
  }
  
  public params: any;
  check: boolean = true

  agInit(params: any): void {
    this.params = params;
    // console.log(this.params)
  }

  refresh(params: any): boolean {
    this.params = params;
    return false;
  }

  onCheckboxChange(event: any, params: any): void {
    // Handle checkbox change event
    const trip_print_enable_url = `/api/shipment_lists/shipment_details.php?table=shipment_and_receiving&command=TRIP_PRINT_TOGGLE`;    
    var postData = {
      lading_uuid: params.data.lading_uuid,
    }
    console.log('Toggle Checkbox', postData);
    this.http.post<any>(trip_print_enable_url, postData)
      .subscribe(response => {
      })      
  }
  
  deselectAll() {
    this.check = false;
  }
}

@Component({
  selector: 'app-custom-renderer',
  template: `<span>{{ name }}</span>&nbsp;&nbsp;
  <button *ngIf="!selected" (click)="deselectAllCheckboxes(name)" style="font-size: 12px; padding: 5px 10px; margin-left: 10px">Deselect All</button>
  <button *ngIf="selected" (click)="selectAllCheckboxes(name)" style="font-size: 12px; padding: 5px 10px; margin-left: 10px">Select All</button>`,
})
export class HeaderRendererComponent implements IHeaderAngularComp {
  
  public params!: IHeaderParams;
  columnName: string = '';
  selected: boolean = false;
  name: string = '';
  uuid: string = '';
  carrier_name: string = '';

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.name = Object(params.displayName).name;
    this.carrier_name = Object(params.displayName).carrier_name;
    this.uuid = Object(params.displayName).uuid;
    console.log('hello world:', this.carrier_name, this.name, this.uuid);
  }

  refresh(params: any): boolean {
    return false;
  }

  constructor(private checkboxService: CheckboxService,) {
    checkboxService.buttonType.subscribe(state => {
      // this.selected = state;
    });
  }

  @ViewChildren(CustomRendererComponent) checkboxRenderers!: QueryList<CustomRendererComponent>;

  ngAfterViewInit() {
  }

  deselectAllCheckboxes(columnKey: string) {
    this.checkboxService.deselectAll(columnKey);
    // console.log('this is the columnkey', columnKey)
    this.selected = !this.selected;
    // this.checkboxService.updateButton(true);
    // this.checkboxService.updateCheckboxState(false); // Trigger to deselect all checkboxes
  }

  selectAllCheckboxes(columnKey: string) {
    this.checkboxService.selectAll(columnKey);
    this.selected = !this.selected;
    this.checkboxService.updateCheckboxState(true); // Trigger to deselect all checkboxes
  }

}


